import { ActivityDestinationViewSearch } from '../common/__generated__/api';

interface PriceDetails {
  leadFormattedPrice?: string | null;
  strikeOutFormattedPrice?: string | null;
  leadPriceLabel?: string | null;
  leadFormattedPoints?: string | null;
  priceAccessibilityText?: string | null;
}

export function getPriceDetails(activity: ActivityDestinationViewSearch.ActivityInlineFragment): PriceDetails {
  const strikeOutFormattedPrice =
    activity.leadTicket &&
    activity.leadTicket.price &&
    activity.leadTicket.price.strikeOut &&
    activity.leadTicket.price.strikeOut.formatted;

  const leadFormattedPrice =
    activity.leadTicket && activity.leadTicket.price && activity.leadTicket.price.lead.formatted;
  const leadFormattedPoints = activity?.leadTicket?.loyaltyPointsOption?.formattedPoints;
  const leadPriceLabel = activity.leadTicket && activity.leadTicket.label;
  const priceAccessibilityText = activity?.leadTicket?.priceAccessibilityText;

  return { strikeOutFormattedPrice, leadPriceLabel, leadFormattedPrice, leadFormattedPoints, priceAccessibilityText };
}
